import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setRate } from '../redux/rates/action';
import { useIsFirstRender } from 'usehooks-ts';
import { fetchClegPrice } from '../services/cleg-token';


const useClegPrice = () => {
  const rates = useSelector((state: any) => state.rates);
  const dispatch = useDispatch()
  const isFirst = useRef(true)
  const handleFetchClegPrice = async () => {
    const price = await fetchClegPrice().catch(() => undefined)
    if (price) dispatch(setRate({ clegInUsd: price, expiresAt: Date.now() + 600000 }))
  };

  useEffect(() => {
    if (!isFirst.current) return
    isFirst.current = false
    if (!rates || (!rates.expiresAt || rates.expiresAt < Date.now())) {
      handleFetchClegPrice()
    }
  }, [])

  return rates
}

export default useClegPrice